<script lang="ts">
  import { imgSrc, type ImgSrcInput } from '#app/lib/image_source'

  const {
    url,
    size = 200,
    alt = '',
  }: {
    url: ImgSrcInput
    size?: number
    alt?: string
  } = $props()
</script>

<div class="image-div">
  {#if url}
    <img src={imgSrc(url, size, size)} {alt} loading="lazy" />
  {/if}
</div>

<style lang="scss">
  @import "general/scss/utils";

  .image-div{
    flex: 1;
    overflow: hidden;
  }
  img{
    object-fit: cover;
    object-position: top;
    width: 100%;
    height: 100%;
  }
</style>
